import {Component, OnInit, EventEmitter, Inject, NgZone} from '@angular/core';
import {FormBuilder, FormArray, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {BehaviorSubject, from} from 'rxjs';
import {map, reduce, startWith, switchMap} from 'rxjs/operators';
import {Select} from "@ngxs/store";
import {RankField} from "../../core/models";
import {Observable} from "rxjs/internal/Observable";
import {Subject} from "rxjs/internal/Subject";
import { Options } from '@angular-slider/ngx-slider';
import {CoreService} from "../../core/services/core.service";
import {RatingSelectDialogComponent} from "../rating-select-dialog/rating-select-dialog.component";
import {MatSnackBar} from "@angular/material/snack-bar";


@Component({
  selector: 'app-ratings-filter-dialog',
  templateUrl: './ratings-filter-dialog.component.html',
  styleUrls: ['./ratings-filter-dialog.component.scss']
})
export class RatingsFilterDialogComponent implements OnInit {

  form: FormGroup;
  typeControls: FormArray;
  types: {} = {};

  @Select((s) => s.core.rankFields) rankFields$;
  years = new BehaviorSubject([]);
  selectedTypes = [];
  buttonLabel = 'Добавить';

  rankFields = [];
  subjectRankFields = new Subject();
  filteredRankFields: Observable<string[]>;
  totalFilteredRatings: number = 0;
  rangeOptions: Options = {
    floor: 1,
    ceil: 2000,
    getPointerColor: (value, pointerType) => '#3f51b5',
  };
  rangeRefresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private formBuilder: FormBuilder,
              private coreService: CoreService,
              private dialogRef: MatDialogRef<RatingsFilterDialogComponent>,
              private dialog: MatDialog,
              private ngZone: NgZone,
              private snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) private data: any) {

    this.form = this.formBuilder.group({
      'year': [null, Validators.required],

      'types': this.formBuilder.array([]),
      'count': [1, ],
      'ratings': [[], Validators.required],
      'range': [[1, 100], ],
      'ratingsFilter': ['', ],
      'countErrorMsg': ['', ]
    }, {'validators': [RatingsFilterDialogComponent.validateForm]});
    console.log(this.rankFields);
    this.typeControls = this.form.get('types') as FormArray;
    this.typeControls.valueChanges.subscribe((v) => this._updateTypes());
    this.form.valueChanges.subscribe(v => {
      this._updateTypes();
      this.subjectRankFields.next(v.ratingsFilter);
    });

    this.form.get('ratings').valueChanges.subscribe(v => {
      this.getRanksMinMax();
    });

    this.filteredRankFields = this.subjectRankFields.pipe(
      startWith(''),
      map((value: string) => {
        const filterValue = value.toLowerCase();
        const filteredRatings = this._filterRankField(this.form.get('year').value, this.selectedTypes, filterValue);
        this.totalFilteredRatings = filteredRatings.length;
        return filteredRatings;
      })
    );

    this.prepareOptions();

  }

  ngOnInit() {
    if(this.data && this.data.val) {
      this.buttonLabel = 'Сохранить';
      this.form.patchValue({
          year: this.data.val.year,
          type_institutional: this.data.val.type_institutional,
          type_subject: this.data.val.type_subject,
          type_nation: this.data.val.type_nation,
          count: this.data.val.count,
          ratings: this.data.val['ratings'].map(val => this.rankFields.filter(r => r.name==val)[0]),
          range: this.data.val.range
      });
    }
  }

  private _updateTypes() {
    this.selectedTypes = [];
    for(let i=0 ; i<this.typeControls.length ; i++) {
      if (this.typeControls.controls[i].get('checked').value) {
        this.selectedTypes.push(this.typeControls.controls[i].get('id').value);
      }
    }

    const filteredRatings = this._filterRankField(this.form.get('year').value, this.selectedTypes, '');
    this.totalFilteredRatings = filteredRatings.length;
  }

  public validateCount() {
    RatingsFilterDialogComponent.validateForm(this.form);
  }

  static validateForm(form: FormGroup) {
    Object.keys(form.controls).forEach(v => {
      if (v == 'count' && form.value.count > form.value.ratings.length) {
        form.controls[v].setErrors({'incorrect': true});
      } else {
        form.controls[v].setErrors(null);
      }
    });
  }

  private _filterRankField(y: number, t: number[], v: string): any[] {
    const filtered = this.rankFields.filter(o => o.year_public == y && t.includes(o.type) && o.name.toLowerCase().indexOf(v) !== -1);
    let groups = [];
    let indexes = {};
    for (let id in this.types) {
      indexes[id] = groups.length;
      groups.push({name: this.types[id].name, options: []});
    }
    for(let i=0 ; i<filtered.length ; i++) {
      groups[indexes[filtered[i].type]].options.push(filtered[i]);
    }
    return groups.filter(g => g.options.length > 0);
  }

  complete() {
    if(this.form.value.ratings.length == 0) {
        this.ngZone.run(() => {
            this.snackBar.open('Для сохранения выберите хотя бы один рейтинг', null, {
                panelClass: 'error-notification',
                duration: 3000
              });
        });
      return;
    }

    let value = this.form.value;
    delete value['ratingsFilter'];
    const label = `Выборка из рейтингов: рейтингов - ${value.ratings.length}, позиции с ${value.range[0]} по ${value.range[1]}`;
    value['ratings'] = value['ratings'].map(v => v.name);

    let payload = {
      label: label,
      type: 'ratings',
      val: value,
    };

    this.dialogRef.close({data: payload});
  }

  prepareOptions() {
    this.rankFields$
      .pipe(
        switchMap((v: Array<RankField>) => from(v)
          .pipe(
            reduce( (acc, v) => acc.concat(v), []),
          )
        )
      )
      .subscribe((v: any[]) => {
        const fields = v.sort((v1, v2) => v1.name.localeCompare(v2.name));
        // const groups = {
        //   'Институциональный': 'Институциональные',
        //   'Предметный': 'Предметные',
        //   'Национальный': 'Национальные'
        // };

        for (let i = 0; i < fields.length; i++) {
          let field = fields[i];
          let obj;
          if (field['type_name'] != null) {
            obj = Object.assign({}, field, {group: field['type_name']});
          } else {
            obj = Object.assign({}, field, {group: ''});
          }
          obj = Object.assign({}, obj, {
            public_name: `${field.short_name}, вузов в базе: ${field.num_ranks}, вузов в рейтинге: ${field.max_ranks}`,
            value: field.name
          });
          this.rankFields.push(obj);
        }

        let years = [];
        let types = [];
        for(let i=0 ; i<v.length ; i++) {
          if(!years.includes(v[i].year_public)) {
            years.push(v[i].year_public);
          }
          if(!types.includes(v[i].type)) {
            types.push(v[i].type);
            this.types[v[i].type] = {id: v[i].type, name: v[i].type_name};
            this.addTypeControl(v[i].type,  v[i].type_name);
          }
        }
        years.sort();
        this.years.next(years);
        this.form.patchValue({
          year: years[years.length-1]
        });
        this.totalFilteredRatings = v.length;
      });

  }

  addTypeControl(id, name) {

    this.typeControls.push(this.formBuilder.group({
      id: [id],
      name: [name],
      checked: [true],
    }));
  }

  getRanksMinMax() {
    const maxes = this.form.get('ratings').value.map(v => v.max_ranks);
    const max = maxes.length ? Math.max.apply(null, maxes) : 1000;

    const newOptions: Options = Object.assign({}, this.rangeOptions);
    newOptions.floor = 1;
    newOptions.ceil = max ? max : 1000;
    this.rangeOptions = newOptions;
  }

  selectRatings() {
    const year = this.form.value.year;

    let config = {
      width: '1100px',
      data: {
        ratings: this.rankFields.filter(x => x['year_public'] == year).sort((v1, v2) => v1.type - v2.type),
        val: this.form.value.ratings.map(x => x.name),
      }
    };
    let dialogRef = this.dialog.open(RatingSelectDialogComponent, config);
    dialogRef.afterClosed().subscribe(
      (value) => {
        if (value) {
          const ids = value.data.val.map(x => x.id);
          const ratings = this.rankFields.filter(x => ids.includes(x.id));
          this.form.patchValue({ratings: ratings});
        }
      }
    );


  }
}
